module.exports = __webpack_public_path__ + "media/images/emblems/Siselen-coat_of_arms-db77e12102a321d7462ddafd0a09836c.svg";